import { useEffect } from "react";

// Lightweight per-page SEO for a CRA single-page app: updates the document
// title, meta description, and canonical link on mount. (Static Open Graph /
// base tags live in public/index.html for crawlers that don't run JS.)

const SITE = "Ace Asia Productions";
const ORIGIN = "https://aceasia.com.sg";

function setMeta(name, content) {
  if (!content) return;
  let el = document.querySelector(`meta[name="${name}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute("name", name);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function setCanonical(path) {
  let el = document.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", "canonical");
    document.head.appendChild(el);
  }
  el.setAttribute("href", `${ORIGIN}${path || ""}`);
}

// Inject (or update) a page-level JSON-LD block. Removed on unmount so each
// page controls its own structured data.
function setJsonLd(data) {
  const id = "page-jsonld";
  let el = document.getElementById(id);
  if (!data) {
    if (el) el.remove();
    return;
  }
  if (!el) {
    el = document.createElement("script");
    el.type = "application/ld+json";
    el.id = id;
    document.head.appendChild(el);
  }
  el.textContent = JSON.stringify(data);
}

export default function Seo({ title, description, path, jsonLd }) {
  useEffect(() => {
    document.title = title ? `${title} · ${SITE}` : `${SITE} · Heritage Books & Collectibles`;
    if (description) setMeta("description", description);
    setCanonical(path !== undefined ? path : window.location.pathname);
  }, [title, description, path]);

  useEffect(() => {
    setJsonLd(jsonLd || null);
    return () => setJsonLd(null);
  }, [jsonLd]);

  return null;
}
